<template>
  <div class="container-fluid mt-4">
    <h1
      class="h1"
      style="text-align: center"
    >
      Break The Glass Request
    </h1>
    <b-row>
      <b-col
        lg="4"
        class="col-centered"
      >
        <b-card :title="'Break The Glass Request Form'">
          <form
            @reset="onReset"
          >
            <b-form-group
              label="Ticket #"
              :description="descriptions.btgTicket"
              :invalid-feedback="invalidFeedbacks.btgTicket"
              :state="validateBtgTicket"
            >
              <b-form-input
                v-model="model.ticket"
                type="text"
                :state="validateBtgTicket"
              />
            </b-form-group>
            <b-form-group
              label="Environment"
              :description="descriptions.environment"
              :invalid-feedback="invalidFeedbacks.environment"
              :state="validateEnvironment"
            >
              <b-form-select
                v-model="model.environment"
                :options="environmentList"
                :required="true"
                @input="onInputChange"
              />
            </b-form-group>
            <b-form-group
              label="Access Role"
              :description="descriptions.accessRole"
              :invalid-feedback="invalidFeedbacks.accessRole"
              :state="validateAccess"
            >
              <b-form-radio-group
                id="rbAccessRoles"
                v-model="model.accessRole"
                :options="accessRoleList"
                name="radioAccessRoles"
                :required="true"
              />
            </b-form-group>
            <b-form-group
              label="Request Type"
              :description="descriptions.requestType"
              :invalid-feedback="invalidFeedbacks.requestType"
              :state="validateRequestType"
            >
              <b-input-group>
                <b-form-radio-group
                  id="rbRequestTypes"
                  v-model="model.requestType"
                  :options="requestTypeList"
                  name="radioRequestTypes"
                  :required="true"
                  @change="onRequestTypeChange"
                />
                <font-awesome-icon
                  id="request-type-info-icon"
                  v-b-hover="handleRequestTypeInfoHover"
                  icon="info-circle"
                  :class="requestTypeInfoHover ? 'text-muted pointer-cursor' : ''"
                  @click="showRequestTypeInfoModal"
                />
                <b-modal
                  ref="requestTypeInfoModal"
                  title="Request Type"
                  hide-footer
                  centered
                >
                  <ul>
                    <li>
                      <strong>Project (default):</strong> Select the project, you are entitled to get access to
                      in the selected 'Environment'. When Request Type is 'Project', Subscription is not selectable.
                    </li>
                    <li>
                      <strong>Subscription:</strong> Make sure 'Environment' is selected to select the appropriate subscription
                      from the list. When Request Type is 'Subscription' Project is not selectable.
                    </li>
                  </ul>
                </b-modal>
              </b-input-group>
            </b-form-group>
            <b-form-group
              label="Subscription"
            >
              <b-form-select
                v-model="model.subscription"
                :options="btgSubscriptionList"
                text-field="subscriptionName"
                value-field="subscriptionName"
                :disabled="isSubscriptionEnabled"
              />
            </b-form-group>
            <b-form-group
              label="Project"
              :description="descriptions.project"
            >
              <v-autocomplete
                v-model="item"
                :items="projects"
                :get-label="getLabel"
                :min-len="0"
                :clearable="true"
                :open-on-clear="true"
                :component-item="template"
                :input-attrs="{projectName: 'project-name'}"
                :disabled="isProjectsEnabled"
                @update-items="filterProjects"
              />
            </b-form-group>
            <div>
              <b-btn
                variant="success"
                :disabled="inProgress"
                @click="showModal"
              >
                <b-spinner
                  v-show="inProgress"
                  small
                />
                <span v-show="!inProgress">Submit Request</span>
                <span v-show="inProgress">Processing...</span>
              </b-btn>
              <b-button
                type="reset"
                variant="primary"
                :disabled="inProgress"
              >
                Reset
              </b-button>
              <b-modal
                ref="modal"
                hide-footer
                title="Confirm"
                header-bg-variant="info"
                header-text-variant="light"
                centered
              >
                <b-container fluid>
                  {{ `Are you sure you want to submit Break the glass access request?` }}
                  <br>
                  <div slot="modal-footer">
                    <b-button
                      class
                      @click="hideModal"
                    >
                      No
                    </b-button>
                    <b-button
                      class
                      variant="primary"
                      type="submit"
                      @click="submitRequest"
                    >
                      Yes
                    </b-button>
                  </div>
                </b-container>
              </b-modal>
            </div>
          </form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from '@/api';
import Vue from 'vue';
import Autocomplete from 'v-autocomplete';
import ItemTemplate from '@/components/AutoCompleteItemTemplate.vue';
import VueToastr2 from 'vue-toastr-2';
import 'vue-toastr-2/dist/vue-toastr-2.min.css';
import 'v-autocomplete/dist/v-autocomplete.css';
import options from '@/logger-options';
import VueLogger from 'vuejs-logger';
import toastr from 'toastr';
import {authService} from '../authService';
window.toastr = toastr;

Vue.use(VueToastr2);
Vue.use(VueLogger, options);
Vue.use(Autocomplete);

const defaultModel = {
  accessRole: '',
  environment: '',
  project: '',
  subscription: '',
  ticket: '',
  user: '',
  requestType: 'project',
};
export default {
  components: {'v-autocomplete': Autocomplete},
  data() {
    return {
      loggedInUser: '',
      projects: [],
      projectsFromApi: [],
      btgSubscriptionList: [],
      btgEnvironmentsFromApi: [],
      item: {projectName: '', product: ''},
      template: ItemTemplate,
      model: {...defaultModel},
      popUp: '',

      /* TODO - When CIE Portal starts supporting all the Federal environments for BTG,
      get governance, environments, region lists from J5 API*/
      environmentList: [
        {value: '', text: 'Select environment'},
        {value: 'federal-prod', text: 'US Federal Prod'},
        {value: 'federal-stage', text: 'US Federal Stage'},
        {value: 'usgov-dev', text: 'US Gov Dev'},
        {value: 'usgov-stage', text: 'US Gov Stage'},
      ],
      accessRoleList: [
        {value: 'reader', text: 'Reader'},
        {value: 'contributor', text: 'Contributor'},
      ],
      requestTypeList: [
        {value: 'project', text: 'Project'},
        {value: 'subscription', text: 'Subscription'},
      ],
      descriptions: {
        btgTicket: 'The secured environment ticket #',
        environment: 'The secured environment',
        requestType: 'The request type for the access',
        accessRole: 'The role for secured environment access',
        project: 'Please select subscription or project for scope. You can only choose one',
      },
      invalidFeedbacks: {
        btgTicket: 'Break The Glass ticket # is required',
        environment: 'Environment is required',
        requestType: 'Request type is required',
        accessRole: 'Access role is required',
        project: 'Project is required',
      },
      requestTypeInfoHover: false,
      inProgress: false,
    };
  },
  computed: {

    validateBtgTicket() {
      if (this.model.ticket.length === 0) {
        return false;
      }
      return true;
    },
    validateAccess() {
      if (this.model.accessRole.length === 0) {
        return false;
      }
      return true;
    },
    validateRequestType() {
      if (this.model.requestType.length === 0) {
        return false;
      }
      return true;
    },
    validateEnvironment() {
      if (this.model.environment === 'Select environment' || this.model.environment === '' ) {
        return false;
      }
      return true;
    },
    isProjectsEnabled() {
      if (this.model.requestType === 'project') {
        return false;
      }
      return true;
    },
    isSubscriptionEnabled() {
      if (this.model.requestType === 'subscription') {
        return false;
      }
      return true;
    },
  },
  async mounted() {
    try {
      const response = await this.getProjectsFromApi();
      this.projects = response.projects;
      this.projectsFromApi = response.projects;
      this.btgEnvironmentsFromApi = await this.getBreakTheGlassEnvironments();
    } catch (error) {
      console.log(error);
    }
  },
  async beforeCreate() {
    this.loggedInUser = await authService.getUser();
    this.model.user = this.loggedInUser.preferred_username;
  },
  methods: {

    checkInput() {
      this.popUp = 'Missing required info: <br/>';
      let pass = true;
      if (!this.model.ticket || this.model.ticket.length === 0) {
        this.popUp+= '<strong>Ticket #</strong><br/>';
        pass = false;
      }
      if (!this.model.environment || this.model.environment.length === 0) {
        this.popUp+= '<strong>Environment</strong><br/>';
        pass = false;
      }
      if (!this.model.accessRole || this.model.accessRole.length === 0) {
        this.popUp+= '<strong>Access Role</strong><br/>';
        pass = false;
      }
      if (!this.model.requestType || this.model.requestType.length === 0) {
        this.popUp+= '<strong>Request Type</strong><br/>';
        pass = false;
      }

      if (this.model.requestType === 'project' && this.item && this.item.projectName.length === 0) {
        this.popUp+= '<strong>Project</strong><br/>';
        pass = false;
      }

      if (this.model.requestType === 'subscription' && this.model.subscription.length === 0) {
        this.popUp+= '<strong>Subscription</strong><br/>';
        pass = false;
      }

      return pass;
    },
    filterProjects (text) {
      this.projects = this.projectsFromApi.filter((item) => {
        return (new RegExp(text.toLowerCase())).test(item.projectName.toLowerCase());
      });
    },
    async getBreakTheGlassEnvironments() {
      const response = await api.getBreakTheGlassEnvironments();
      return response;
    },

    getLabel (item) {
      if (item) {
        return item.projectName;
      }
      return '';
    },
    async getProjectsFromApi() {
      const response = await api.getProjects();
      return response;
    },
    handleRequestTypeInfoHover(hovered) {
      this.requestTypeInfoHover = hovered;
    },
    hideModal() {
      this.$refs['modal'].hide();
    },
    invalidFeedback() {
      this.$toastr.error(this.popUp, '', {
        positionClass: 'toast-bottom-center',
        timeOut: '200000',
        toastClass: 'toast-style',
      });
    },
    async onInputChange() {
      if (this.model.environment != '') {
        const selectedEnvironment = this.btgEnvironmentsFromApi.find((item) => item.environmentName === this.model.environment);
        if (selectedEnvironment && selectedEnvironment.subscriptions.length > 0) {
          // If user wants to unselect any selected subscription
          this.btgSubscriptionList = [{subscriptionName: ''}];
          this.btgSubscriptionList = this.btgSubscriptionList.concat(selectedEnvironment.subscriptions);
        }
      }
    },
    async onRequestTypeChange() {
      if (this.model.requestType === 'project') {
        this.model.subscription = '';
        const response = await this.getProjectsFromApi();
        this.projects = response.projects;
      } else {
        this.item = {projectName: '', product: ''};
        this.model.project = '';
      }
    },
    onReset: function (evt) {
      evt.preventDefault();
      this.model = {...defaultModel};
      this.btgSubscriptionList = [];
    },
    showModal() {
      if (this.checkInput()) {
        this.$refs['modal'].show();
      } else {
        this.invalidFeedback();
        return;
      }
    },
    async submitRequest() {
      // Item gets set to null when a project is cleared from the autocomplete
      this.model.project = this.item!= null ? this.item.projectName: '';
      this.model.user = this.loggedInUser.preferred_username;
      const data = this.model;
      this.hideModal();
      this.inProgress = true;
      try {
        await api.createBreakTheGlassRequest(data);
        this.successFeedback();
        this.model = {...defaultModel};
      } catch (err) {
        if (err.response && err.response.data && err.response.data.error) {
          let e = err.response.data.error;
          try {
            e = JSON.parse(err.response.data.error);
          } catch (parseError) {} // eslint-disable-line no-empty
          if (e.primary) {
            this.popUp =
              `Primary Error: ${e.primary.status} ${e.primary.statusText} ` + '<br/>' +
              `${e.primary.data}` + '<br/>' +
              `Secondary Error: ${e.secondary.status} ${e.secondary.statusText} ` + '<br/>' +
              `${e.secondary.data}`; // Change this as per BTG API when it errors out
          } else {
            this.popUp = `Error: ${e}`;
          }
        } else {
          this.popUp = 'Some error occured while processing the Break the glass request';
        }
        this.invalidFeedback();
      }
      this.inProgress = false;
    },
    successFeedback() {
      this.$toastr.success('Your break the glass request was processed. Please check your email for the access link', '', {
        positionClass: 'toast-bottom-center',
        timeOut: '200000',
        toastClass: 'toast-style',
      });
    },
    showRequestTypeInfoModal() {
      this.$refs['requestTypeInfoModal'].show();
    },
  },
};
</script>

<style>
.col-centered {
  float: none;
  margin: 0 auto;
}

#loading-div {
  position: fixed;
  bottom: 0;
  left: 85%;
}

#loading-test {
  color: rgb(238, 132, 83);
  padding-left: 35%;
}

#loading-icon {
  width: 100%;
  height: 100%;
}

</style>
<style lang="stylus">
.v-autocomplete
  .v-autocomplete-input-group
    .v-autocomplete-input
      font-size 1.0em
      padding 10px 15px
      box-shadow none
      border 1px solid #ced4da
      width 100%
      height 100%
      outline none
      background-color #fff
    &.v-autocomplete-selected
      .v-autocomplete-input
        color black
        background-color #fff
  .v-autocomplete-list
    width 100%
    text-align left
    border none
    border-top none
    max-height 400px
    overflow-y auto
    border-bottom 1px solid #157977
    .v-autocomplete-list-item
      cursor pointer
      background-color #fff
      padding 10px
      border-bottom 1px solid #157977
      border-left 1px solid #157977
      border-right 1px solid #157977
      &:last-child
        border-bottom none
      &:hover
        background-color #eee
      abbr
        opacity 2.0
        font-size 0.8em
        display block
pre
  text-align left
  white-space pre-wrap
  background-color #eee
  border 1px solid silver
  padding 20px !important
  border-radius 10px
  font-family inherit
.left
  text-align left
.note
  border-left 5px solid #ccc
  padding 10px
</style>
